export default class EnrollmentModel {
  constructor(enrollmentInfo) {
    this._courseOfferingId = enrollmentInfo.courseOfferingId;
    this._benefitsEligible = enrollmentInfo.benefitsEligible;
    this._partnerBenefitEligible = enrollmentInfo.partnerBenefitEligible;
    this._creditEligible = enrollmentInfo.creditEligible;
    this._courseOfferingProgress = enrollmentInfo.courseOfferingProgress;
    this._courseConnectionOrigin = enrollmentInfo.courseConnectionOrigin;
    this._enrollmentDate = enrollmentInfo.enrollmentDate;
    this._enrollmentId = enrollmentInfo.enrollmentId;
    this._progressPageURL = enrollmentInfo.progressPageURL;
    this._enrollmentMode = enrollmentInfo.enrollmentMode;
    this._enrollmentStatus = enrollmentInfo.enrollmentStatus;
    this._courseCompletedDate = enrollmentInfo.courseCompletedDate;
    this._finalGrade = enrollmentInfo.finalGrade;
    this._grade = enrollmentInfo.grade;
    this._currentGrade = enrollmentInfo.currentGrade;
    this._idVerify = enrollmentInfo.idVerify;
    this._idVerifyDate = enrollmentInfo.idVerifyDate;
    this._creditConverted = enrollmentInfo.creditConverted;
    this._creditConvertedDate = enrollmentInfo.creditConvertedDate;
    this._numberOfCreditsEarned = enrollmentInfo.numberOfCreditsEarned;
    this._proctoringStatus = enrollmentInfo.proctoringStatus;
    this._proctoringDate = enrollmentInfo.proctoringDate;
    this._buttonLabel = enrollmentInfo.buttonLabel;
    this._buttonAction = enrollmentInfo.buttonAction;
    this._unenroll = enrollmentInfo.unenroll;
    this._idVerificationDeadline = enrollmentInfo.idVerificationDeadline;
    this._isCourseSelected = enrollmentInfo.isCourseSelected;
    this._hideCourse = enrollmentInfo.hideCourse;
    this._benefitType = enrollmentInfo.benefitType;
    this._isPartnerOverride = enrollmentInfo.isPartnerOverride;
    this._transcriptedDate = enrollmentInfo.transcriptedDate;
    // ULC-3378: approved override keeps Add to Transcript past the one-year window
    this._creditWindowOverride = enrollmentInfo.creditWindowOverride === true;
    this._canvasUserId = enrollmentInfo.canvasUserId;
    this._canvasCourseId = enrollmentInfo.canvasCourseId;
    this._canvasEnrollmentId = enrollmentInfo.canvasEnrollmentId;
    this._courseCompletionConfetti = enrollmentInfo.courseCompletionConfetti;
    this._courseRegistrationDate = enrollmentInfo.courseRegistrationDate;
    this._paymentMethod = enrollmentInfo.paymentMethod || '';
    this._multiEnrollmentType = enrollmentInfo.enrollmentType || '';
    this._enrollmentModeVerifiedDate = enrollmentInfo.enrollmentModeVerifiedDate || '';
    this._courseDropDeadline = parseInt((enrollmentInfo.courseDropDeadline || '0').split(' ')[0]);
    this._enrollmentStatusInactiveDate = enrollmentInfo.enrollmentStatusInactiveDate;
    this._isPathwayCourse = false;
    this._isCourseRefunded = enrollmentInfo.courseRefundedStatus;
    this._verifiedTransactionId = enrollmentInfo.verifiedTransactionId;
    this._invisibleVoucher = enrollmentInfo.invisibleVoucher || null;
    this._completionLtiUrl = enrollmentInfo.completionLtiUrl || null;

    if (enrollmentInfo.courseInfo)
      this._courseInfo = {
        _courseId: enrollmentInfo.courseInfo.courseId,
        _asuCredits: +enrollmentInfo.courseInfo.asuCredits,
        _courseDescription: enrollmentInfo.courseInfo.courseDescription,
        _courseEndDate: enrollmentInfo.courseInfo.courseEndDate,
        _courseFinalisedDate: enrollmentInfo.courseInfo.courseFinalisedDate,
        _courseName: enrollmentInfo.courseInfo.courseName,
        _courseOfferingId: enrollmentInfo.courseInfo.courseOfferingId,
        _canvasCourseId: enrollmentInfo.canvasCourseId,
        _courseStartDate: enrollmentInfo.courseInfo.courseStartDate,
        _courseTooltip: enrollmentInfo.courseInfo.courseTooltip,
        _openEdxCourseId: enrollmentInfo.courseInfo.openEdxCourseId,
        _openEdxCourseUrl: enrollmentInfo.courseInfo.openEdxCourseUrl,
        _openEdxViewCourseUrl: enrollmentInfo.courseInfo.openEdxViewCourseUrl,
        _courseLogo: enrollmentInfo.courseInfo.courseLogo,
        _eaCourseURL: enrollmentInfo.courseInfo.eaCourseURL,
        _term: enrollmentInfo.courseInfo.term,
        _coursePrefix: enrollmentInfo.courseInfo.coursePrefix,
        _coursePrefixDisplayLabel: enrollmentInfo.courseInfo.coursePrefixDisplayLabel,
        _coursePrefixAliases: enrollmentInfo.courseInfo.coursePrefixAliases,
        _isProctoringExamFound: enrollmentInfo.courseInfo.isProctoringExamFound,
        _courseType: enrollmentInfo.courseInfo.courseType,
        _deadlineCounter: enrollmentInfo.courseInfo.deadlineCounter,
        _courseBrief: enrollmentInfo.courseInfo.courseBrief,
        _creditConversionPrice: enrollmentInfo.courseInfo.creditConversionPrice,
        _creditEligibilityPrice: enrollmentInfo.courseInfo.creditEligibilityPrice,
        // December 2024 Early Conversion Campaign (ULC-2637)
        _campaignEligible: enrollmentInfo.courseInfo.campaignEligible || false,
        _campaignCode: enrollmentInfo.courseInfo.campaignCode || '',
        _creditConversionOriginalPrice:
          enrollmentInfo.courseInfo.creditConversionOriginalPrice || enrollmentInfo.courseInfo.creditConversionPrice,
        _campaignDiscountAmount: enrollmentInfo.courseInfo.campaignDiscountAmount || 0,
        _lms: enrollmentInfo.courseInfo.LMS,
        _courseOrg: enrollmentInfo.courseInfo.courseOrg,
        _courseRun: enrollmentInfo.courseInfo.courseRun,
        _courseNum: enrollmentInfo.courseInfo.courseNum,
        _coursePrerequisiteLabel: enrollmentInfo.courseInfo.coursePrerequisiteLabel,
        _coursePacing: enrollmentInfo.courseInfo.coursePacing,
        _courseDesignations: enrollmentInfo.courseInfo.courseDesignations,
        _courseLength: enrollmentInfo.courseInfo.courseLength,
        _courseEffortPerHour: enrollmentInfo.courseInfo.courseEffortPerHour,
        _isCourseResetAllowed: enrollmentInfo.courseInfo.isCourseResetAllowed,
        _isCourseResetRequested: enrollmentInfo.courseInfo.isCourseResetRequested,
        _courseRegistrationDate: enrollmentInfo.courseInfo.courseRegistrationDate,
        _courseCreditEligible: enrollmentInfo.courseInfo.creditEligible,
        _enrollmentMode: enrollmentInfo.enrollmentMode,
        _courseDropDeadline: parseInt((enrollmentInfo.courseDropDeadline || '0').split(' ')[0]),
        _enrollmentStatus: enrollmentInfo.enrollmentStatus,
        _idVerificationDeadline: enrollmentInfo.idVerificationDeadline,
        _enrollmentModeVerifiedDate: enrollmentInfo.enrollmentModeVerifiedDate || '',
        _orientationStartDate: enrollmentInfo.courseInfo.orientationStartDate,
        _creditConversionStatus: enrollmentInfo.courseInfo.creditConversionStatus,
        _termStartDate: enrollmentInfo.courseInfo.termStartDate,
        _termEndDate: enrollmentInfo.courseInfo.termEndDate
      };
  }

  get courseListPageData() {
    return {
      benefitsEligible: this._benefitsEligible,
      enrollmentId: this._enrollmentId,
      courseOfferingId: this._courseOfferingId,
      enrollmentDate: this._enrollmentDate,
      courseName: this._courseInfo?._courseName || '',
      courseStartDate: this._courseInfo?._courseStartDate || '',
      enrollmentStatus: this._enrollmentStatus,
      courseDescription: this._courseInfo?._courseTooltip || '',
      courseType: this._courseInfo?._courseType || '',
      enrollmentMode: this._enrollmentMode,
      LMS: this._courseInfo?._lms || '',
      canvasCourseId: this._canvasCourseId,
      canvasEnrollmentId: this._canvasEnrollmentId,
      canvasUserId: this._canvasUserId,
      coursePrerequisiteLabel: this._courseInfo?._coursePrerequisiteLabel || '',
      coursePacing: this._courseInfo?._coursePacing || '',
      courseDesignations: this._courseInfo?._courseDesignations || [],
      courseLength: this._courseInfo?._courseLength || '',
      courseEffortPerHour: this._courseInfo?._courseEffortPerHour || '',
      isCourseResetAllowed: this._courseInfo?._isCourseResetAllowed || false,
      isCourseResetRequested: this._courseInfo?._isCourseResetRequested || false,
      creditEligible: this._courseInfo?._creditEligible || false,
      courseRegistrationDate: this._courseInfo?._courseRegistrationDate || '',
      enrollmentStatusInactiveDate: this._enrollmentStatusInactiveDate,
      courseDropDeadline: this._courseDropDeadline,
      enrollmentModeVerifiedDate: this._enrollmentModeVerifiedDate || ''
    };
  }

  get courseCompletionInfo() {
    return {
      enrollmentId: this._enrollmentId,
      courseCompletedDate: this._courseCompletedDate,
      creditEligible: this._creditEligible,
      courseCompletionConfetti: this._courseCompletionConfetti,
      creditConverted: this._creditConverted,
      creditConvertedDate: this._creditConvertedDate,
      creditConversionStatus: this._creditConversionStatus
    };
  }
}
